import { useTranslation } from "../../localization/useTranslation";
import { useLanguageMenuStyle } from "./LanguageMenu.styles";
import { useUserContext } from "../../auth/userContextProvider/UserContextProvider";
import { Box } from "@mui/material";
import React from "react";

export interface ILanguageMenu {}

function LanguageMenu(props: ILanguageMenu) {
    const { changeLanguage } = useTranslation();
    const styles = useLanguageMenuStyle();
    const userContext = useUserContext();

    return (
        <>
            <Box component={"span"} onClick={() => changeLanguage("da")} sx={[userContext.language === "da" ? styles.activeLanguage : {}, styles.language]}>
                DA
            </Box>
            <Box component={"span"} sx={styles.splitter}>
                |
            </Box>
            <Box component={"span"} onClick={() => changeLanguage("en")} sx={[userContext.language === "en" ? styles.activeLanguage : {}, styles.language]}>
                EN
            </Box>
            {userContext.germanEnabled && (
                <>
                    <Box component={"span"} sx={styles.splitter}>
                        |
                    </Box>
                    <Box
                        component={"span"}
                        onClick={() => changeLanguage("de")}
                        sx={[userContext.language === "de" ? styles.activeLanguage : {}, styles.language]}
                    >
                        DE
                    </Box>
                </>
            )}
        </>
    );
}

export default LanguageMenu;
